/* eslint-disable @typescript-eslint/no-explicit-any */

import { clearDasherToken, clearTrelloToken } from '@shared/index'
import { type Trello } from '../types/trello'
import { PUP_ID } from '../config'
import { apiClient } from '../api/api'
import { clearAllStoredCardCustomers } from '../storage'

export async function  getRemoveData (
  t: Trello.PowerUp.IFrame,
): Promise<void> {
  await apiClient.revokeQuickbooksAuth(t)
  clearTrelloToken(t, PUP_ID)
  clearDasherToken(t)
  // The badge mirrors QuickBooks customer names into Trello's own card data, so
  // removing the power-up has to take those with it.
  await clearAllStoredCardCustomers(t)
}
